import gql from 'graphql-tag'

const BRAND_TO_BRAND_CATEGORY_DELETE =  gql`mutation ($brandId: Int!, $brandCategoryId: Int!){
    delete_brand_to_brand_category(where:
        {_and:[
            {brand_id: {_eq: $brandId}},
            {brand_category_id: {_eq: $brandCategoryId}}
        ]})
        {
            affected_rows
        }
    }`;

const BUSINESS_DELETE =  gql`mutation ($businessId: Int!){
    delete_business(where: {id: {_eq: $businessId}})
        {
            affected_rows
        }
    }`;

const DELEGATED_USER_DELETE =  gql`mutation ($delegatedUserId: Int!){
    delete_delegated_user(where: 
        {_and:[
            {delegated_user_id: {_eq: $delegatedUserId}}
        ]})
        {
            affected_rows
        }
    }`;


const CLASS_DELETE =  gql`mutation ($classId: Int!){
    delete_class(where:{id: {_eq: $classId}})
    {
        affected_rows
    }
}`;    

const CLASS_CATEGORY_DELETE =  gql`mutation ($classId: Int!, $categoryId: Int!){
    delete_class_category(where:{_and:[

        {class_id: {_eq: $classId}},
        {category_id: {_eq: $categoryId}}
    ]})
    {
        affected_rows
    }
}`;

const SLOT_DELETE =  gql`mutation ($slotId: Int!){
    delete_slot(where:{id: {_eq: $slotId}})
    {
        affected_rows
    }
}`;    

const NOTIFICATION_DELETE =  gql`mutation ($notificationId: bigint!){
    delete_user_notification(where:{id: {_eq: $notificationId}})
    {
        affected_rows
    }
}`;

const ALL_NOTIFICATIONS_DELETE =  gql`mutation{
    delete_user_notification(where: {})
    {
        affected_rows
    }
}`; 

const BUSINESS_NOTIFICATION_DELETE =  gql`mutation ($notificationId: bigint!){
    delete_business_notification(where:{id: {_eq: $notificationId}})
    {
        affected_rows
    }
}`;

const ALL_BUSINEESS_NOTIFICATIONS_DELETE =  gql`mutation($businessId: Int!){
    delete_business_notification(where:{business_id: {_eq: $businessId}})
    {
        affected_rows
    }
}`; 

const DELETE_DEVICE = gql`mutation($deviceId: bigint!){

    delete_user_device(where:{id: {_eq: $deviceId}})
    {
        
        affected_rows
    }
}`



export default {

    brand_to_brand_category_delete: BRAND_TO_BRAND_CATEGORY_DELETE,
    business_delete: BUSINESS_DELETE,
    delegated_user_delete: DELEGATED_USER_DELETE,
    class_delete: CLASS_DELETE,
    class_category_delete: CLASS_CATEGORY_DELETE,

    slot_delete: SLOT_DELETE,

    notification_delete :NOTIFICATION_DELETE,

    business_notification_delete: BUSINESS_NOTIFICATION_DELETE,

    all_notifications_delete: ALL_NOTIFICATIONS_DELETE,

    all_business_notifications_delete: ALL_BUSINEESS_NOTIFICATIONS_DELETE,

    delete_device: DELETE_DEVICE

}